import React, { useState, useEffect} from 'react'
import cn from 'classnames'
import pageBg from '../../img/start-page-bg.webp'
import tuman from '../../img/tuman.png'
import modalBg from '../../img/modal-bg-1.svg'
import contentImg1 from '../../img/start-game-img1.png'

import sun2 from '../../img/sun2.png'
import sun3 from '../../img/sun3.png'
import sun4 from '../../img/sun4.png'
import sun5 from '../../img/sun5.png'
import sun6 from '../../img/sun6.png'
import {Preloader, SpriteSvg} from '../../components'
import {useMousePosition} from '../../utils'


const StartGamePage = ({
	handleNextPage,
	isLoaded,
	setIsLoaded,
	setIsPlayMusic,
	trainPage,
}) => {
	const [isYes, setIsYes] = useState(true)

	const handleStart = () => {
		setIsYes(false)
		setIsPlayMusic(true)
	}

	const position = useMousePosition()
	return (
		<>

		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>

		<div className={cn(
			'full-page',
			'start-page',
			isLoaded && 'active'
		)} >
			<div className="page-bg right-sun">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='smoke-img' style={{transform: `translate(-${position.x / 100}px, -${position.y / 75}px)`}} src={tuman} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={sun6} alt=""/>
			</div>
			<div className={cn(
				'overlay',
				!isYes && 'disabled'
			)}/>
			<div className={cn(
				'page-content',
				'active'
			)}>
				<div className={cn(
					'modal',
					!isYes && 'disabled'
				)}>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>
					<div className="modal-content">
						<div className="title">
							<p>Вам есть 18 лет?</p>
						</div>
						<div className="btn-wrap jcc">
							<a target='_blank' href='https://www.tn.ru/' className="btn white mg-r-24">
								<SpriteSvg id='start-page-btn-white-bg'/>
								<span>Нет</span>
							</a>
							<div onClick={() => handleStart()} className="btn green">
								<SpriteSvg id='start-page-btn-green-bg'/>
								<span>Да</span>
							</div>
						</div>
					</div>
				</div>

				<div className={cn(
					'content',
					'center',
					isYes && 'disabled'
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

					<div className="btn-wrap center">
						<div onClick={()=>{
							window.ym(1188538,'reachGoal','start-igry')
							handleNextPage(trainPage)
						}}
							className="btn green">
							<SpriteSvg id='start-page-btn-white-bg2'/>
							<p>Начать игру</p>
						</div>

					</div>
				</div>

			</div>

		</div>
		</>
	)

}

export default StartGamePage